import React from 'react';
import MultiUser from 'components/MultiUser';
import { setBodyOverflow } from './helpers';

type State = {
  shown: boolean;
  courseId?: number;
};
type ActionType = 'show' | 'hide';
type Action = {
  type: ActionType;
  courseId?: number;
  delegate?: { key: string; uuid: string; value: string };
};
type Dispatch = (action: Action) => void;

const BookingModalDispatchContext = React.createContext<Dispatch | undefined>(
  undefined
);

function bookingModalReducer(state: State, action: Action) {
  switch (action.type) {
    case 'show': {
      setBodyOverflow(false);
      return {
        shown: true,
        courseId: action.courseId,
        delegate: action.delegate
      };
    }
    case 'hide': {
      setBodyOverflow(true);
      return { shown: false, courseId: undefined, delegate: undefined };
    }
  }
}

function BookingModalProvider({ children }: { children: React.ReactNode }) {
  const [state, dispatch] = React.useReducer(bookingModalReducer, {
    shown: false,
    courseId: undefined,
    delegate: undefined
  });
  return (
    <BookingModalDispatchContext.Provider value={dispatch}>
      <MultiUser
        isOpen={state.shown}
        onClose={() => {
          dispatch({ type: 'hide' });
        }}
        initialCourse={state.courseId}
        initialUser={state.delegate}
      />
      {children}
    </BookingModalDispatchContext.Provider>
  );
}

function useBookingModalDispatch() {
  const context = React.useContext(BookingModalDispatchContext);
  if (context === undefined) {
    throw new Error('BookingModalDispatch must be used with BookingModalProvider');
  }
  return context;
}

export { BookingModalProvider, useBookingModalDispatch };
